import React from 'react';
import { keyframes } from '@emotion/react';
import { styled } from '@mui/material/styles';
// import AssistantIcon from "@mui/icons-material/Assistant";
// import logo from "../../public/assets/images/shopwizelogo.png";
import logo from "../../public/assets/images/replybot/replyBotLogo500x500.png";
import Box from '@mui/material/Box';

// Define la animación de colores
// const pulseAnimation = keyframes`
//   0% { background-color: #1976d2; }
//   25% { background-color:rgb(255, 140, 0); }
//   50% { background-color:rgb(163, 147, 0); }
//   75% { background-color:rgb(255, 140, 0); }
//   100% { background-color: #1976d2; }
// `;

const pulseAnimation = keyframes`
  0% { background-color:rgb(255, 140, 0); }
  50% { background-color:rgb(255, 81, 0); }
  100% { background-color:rgb(255, 140, 0); }
`;

// Contenedor para el ícono que permite posicionamiento relativo
const IconContainer = styled(Box)({
  position: 'relative',
  display: 'inline-flex',
  cursor: 'pointer',
});

// Creamos un componente estilizado específicamente para la animación
const AnimatedBg = styled('div')(({ animate }) => ({
  position: 'absolute',
  width: '60%',
  height: '60%',
  borderRadius: '50%',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: -1,
  animation: animate ? `${pulseAnimation} 2s infinite` : 'none',
}));

const AnimatedAssistantIcon = ({ 
  size = 32, 
  isAnimating = false, 
  onClick = null,
  ...props 
}) => {
  return (
    <IconContainer onClick={onClick} {...props}>
      {/* <AnimatedBg animate={isAnimating} /> */}
      {/* <AssistantIcon 
        sx={{ 
          fontSize: size,
          color: 'white',
          position: 'relative',
          zIndex: 1
        }} 
      /> */}
      <img
        src={process.env.REACT_APP_FRONT_URL+"/assets/images/replybot/replyBotLogo500x500.png"}
        // src={logo}
        className="App-logo mrkPT1em"
        alt="logo"
        style={{ width: "40px" }}
      />
    </IconContainer>
  );
};

export default AnimatedAssistantIcon;